import { styled } from '@mui/material/styles'
import FormLabel from '@mui/material/FormLabel'

export const SliderLabel = styled(FormLabel)({
  position: 'absolute',
  left: -6,
  top: -4,
  transform: 'scale(0.75)',
})

export const SliderContainer = styled('div')({
  width: '90%',
  height: 80,
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
})
